import React from 'react';
import {ItemPresenter} from "../ItemPresenter";

const className = "plantmaterial";

function GIPlantMaterial() {
  return (
    <ItemPresenter imagePath={`/images/gameItems/${className}.png`} tooltipText={className} />
  );
}

export default GIPlantMaterial;